import _ from 'lodash';
import { loadingCycle } from './page';
import api from '../../utils/service';

const GET_DEALER_SUCCESS = 'redux/dealer/GET_DEALER_SUCCESS';
const GET_DEALER_FAIL = 'redux/dealer/GET_DEALER_FAIL';

const initialState = {};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_DEALER_SUCCESS:
      return {
        ...state,
        details: action.data,
      };
    case GET_DEALER_FAIL:
      return {
        ...state,
        error: action.error,
      };
    default:
      return state;
  }
}

export function getDealer(id) {
  return (dispatch) =>
    loadingCycle(api.get(`/dealers/${id}`))
      .then(({ data }) => dispatch(getDealerSuccess(data)))
      .catch((error) => dispatch(getDealerFail(error)));
}

export function getDealerSuccess(data) {
  return {
    type: GET_DEALER_SUCCESS,
    data,
  };
}

export function getDealerFail(error) {
  return {
    type: GET_DEALER_FAIL,
    error: _.get(error, 'response.data.message', _.get(error, 'message')),
  };
}
